import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import store from "store2";
var _namespace = /*#__PURE__*/new WeakMap();
var _store = /*#__PURE__*/new WeakMap();
var _storage = /*#__PURE__*/new WeakMap();
var _options = /*#__PURE__*/new WeakMap();
export var Storage = /*#__PURE__*/function () {
  function Storage() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Storage);
    _classPrivateFieldInitSpec(this, _namespace, "_pjyy");
    _classPrivateFieldInitSpec(this, _store, store.namespace(_classPrivateFieldGet(_namespace, this)));
    _classPrivateFieldInitSpec(this, _storage, _classPrivateFieldGet(_store, this));
    _classPrivateFieldInitSpec(this, _options, {
      type: "localStorage",
      namespace: undefined
    });
    _classPrivateFieldSet(_options, this, Object.assign(_classPrivateFieldGet(_options, this), options));
    var type = _classPrivateFieldGet(_options, this).type;
    var namespace = _classPrivateFieldGet(_options, this).namespace;
    if (namespace) {
      _classPrivateFieldSet(_store, this, _classPrivateFieldGet(_store, this).namespace(namespace));
    }
    if (type === "localStorage") {
      _classPrivateFieldSet(_storage, this, _classPrivateFieldGet(_store, this).local);
    } else if (type === "sessionStorage") {
      _classPrivateFieldSet(_storage, this, _classPrivateFieldGet(_store, this).session);
    } else if (type === "page") {
      _classPrivateFieldSet(_storage, this, _classPrivateFieldGet(_store, this).page);
    }
  }
  return _createClass(Storage, [{
    key: "get",
    value: function get(key, alt) {
      return _classPrivateFieldGet(_storage, this).get(key, alt);
    }
  }, {
    key: "set",
    value: function set(key, data, overwrite) {
      return _classPrivateFieldGet(_storage, this).set(key, data, overwrite);
    }
  }, {
    key: "has",
    value: function has(key) {
      return _classPrivateFieldGet(_storage, this).has(key);
    }
  }, {
    key: "add",
    value: function add(key, data) {
      return _classPrivateFieldGet(_storage, this).add(key, data);
    }
  }, {
    key: "keys",
    value: function keys(fillList) {
      return _classPrivateFieldGet(_storage, this).keys(fillList);
    }
  }, {
    key: "clear",
    value: function clear() {
      return _classPrivateFieldGet(_storage, this).clear();
    }
  }, {
    key: "each",
    value: function each(fn, fill) {
      return _classPrivateFieldGet(_storage, this).each(fn, fill);
    }
  }, {
    key: "size",
    value: function size() {
      return _classPrivateFieldGet(_storage, this).size();
    }
  }, {
    key: "remove",
    value: function remove(key, alt) {
      return _classPrivateFieldGet(_storage, this).remove(key, alt);
    }
  }, {
    key: "getAll",
    value: function getAll(fillObj) {
      return _classPrivateFieldGet(_storage, this).getAll(fillObj);
    }
  }, {
    key: "setAll",
    value: function setAll(data, overwrite) {
      return _classPrivateFieldGet(_storage, this).setAll(data, overwrite);
    }
  }, {
    key: "transact",
    value: function transact(key, fn, alt) {
      return _classPrivateFieldGet(_storage, this).transact(key, fn, alt);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      return _classPrivateFieldGet(_storage, this).clearAll();
    }
  }, {
    key: "original",
    value: function original() {
      return _classPrivateFieldGet(_storage, this);
    }
  }, {
    key: "isFake",
    value: function isFake() {
      return _classPrivateFieldGet(_store, this).isFake();
    }
  }, {
    key: "page",
    value: function page() {
      return _classPrivateFieldGet(_store, this).page;
    }
  }, {
    key: "local",
    value: function local() {
      return _classPrivateFieldGet(_store, this).local;
    }
  }, {
    key: "session",
    value: function session() {
      return _classPrivateFieldGet(_store, this).session;
    }
  }]);
}();